// extracted by mini-css-extract-plugin
export default {"tabRow":"q0EOMO2Ecd2pwtUaEUTu","tabList":"D516UkjN0KVH_6ORMR03","tabButton":"tWjbvvW03wFZ5W_eq_ZM","active":"rzEcInwEmj2ntrC8CrfY","addPaymentButton":"Sf8Ings3nrgWweK0l8GA"};